import { render, staticRenderFns } from "./TopicCardPoolWeapon.vue?vue&type=template&id=a0ed2158&scoped=true"
import script from "./TopicCardPoolWeapon.vue?vue&type=script&lang=js"
export * from "./TopicCardPoolWeapon.vue?vue&type=script&lang=js"
import style0 from "./TopicCardPoolWeapon.vue?vue&type=style&index=0&id=a0ed2158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ed2158",
  null
  
)

export default component.exports